<template>
  <div class="login-container">
    <div class="login-form">
      <h1 class="logo"><em>Data</em>poort</h1>
      <p v-if="mailSent">
        Er is een email verstuurd naar je emailadres zoals deze bij ons bekend is, daarin vindt je
        de vervolgstappen om je wachtwoord te kunnen veranderen.<br /><br />
        <strong>LET OP: de link in de mail is slechts 2 uur geldig</strong>
      </p>
      <p v-else-if="error">
        Er is een fout opgetreden tijdens het aanvragen van een nieuw wachtwoord, neem contact op
        met jan@jan.tm.
      </p>
      <form @submit="forgotPassword($event)" v-else>
        <input placeholder="Emailadres" v-model="email" type="text" autocomplete="email" />
        <input type="submit" value="Verstuur" class="btn btn-primary" :disabled="loading" />
        <router-link class="btn btn-secondary" :to="{ name: 'login' }">Inloggen</router-link>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineComponent, ref } from 'vue'
import axios from 'axios'

const email = ref('')
const error = ref(false)
const loading = ref(false)
const mailSent = ref(false)

const forgotPassword = (event: Event) => {
  loading.value = true
  event.preventDefault()
  axios
    .post('/api/forgot_password', {
      email: email.value,
    })
    .then(
      () => {
        mailSent.value = true
        loading.value = false
      },
      () => {
        error.value = true
      },
    )
  return false
}
defineComponent({
  name: 'ForgotPassword',
})
</script>
